import { Add, Delete, Edit, Visibility } from "@material-ui/icons";
import {
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Typography,
} from "@material-ui/core";
import React, { createRef, useState } from "react";
import {
  deleteShipData,
  fetchShipData,
  getShipName,
} from "../../../../services/shipDataService";

import CreateDialog from "./CreateDialog";
import CustomAlert from "../../../components/CustomAlert";
import CustomTable from "../../../../components/GovGrMaterialTable";
import { Helmet } from "react-helmet-async";
import UpdateDialog from "./UpdateDialog";
import queryFunction from "../../../../utils/queryFunction";
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import { useHistory } from "react-router-dom";
import useLocale from "../../../../hooks/useLocale";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import dayjs from "dayjs";
import GovGrBreadcrumbs from "../../../../components/GovGrBreadCrumbs";
import GovGrDeleteModalDialog from "../../../../components/GovGrDeleteModalDialog";

const Divider = styled(MuiDivider)(spacing);

function ShipData() {
  const { t } = useLocale();
  let history = useHistory();

  let { id } = useParams();

  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isUpdateDialogOpen, setIsUpdateDialogOpen] = useState(false);

  const [selectedItem, setSelectedItem] = useState({});
  const [isError, setIsError] = useState(false);

  const tableRef = createRef();

  const refreshTable = () => {
    if (tableRef.current) {
      tableRef.current.onQueryChange();
    }
  };

  const { data: singleShipName } = useQuery(["getShipname", id], () =>
    getShipName(id)
  );

  return (
    <>
      <Helmet title={t("Ships")} />
      <Typography variant="h3" gutterBottom display="inline">
        {t("Ship History")}
      </Typography>
      <GovGrBreadcrumbs
        segments={[
          { href: "/", label: t("Dashboard") },
          { href: "#", label: t("Nautical Crew List") },
          { href: "/nauticalcrewlist/ship", label: t("Ships") },
          { href: "", label: singleShipName?.dds },
        ]}
      />
      <Divider my={6} />

      <CustomAlert
        open={isError}
        close={() => {
          // refetch();
        }}
        message={t("A network error occured, please try again later")}
      />
      <CustomTable
        // isLoading={isLoading}
        ref={tableRef}
        columns={[
          {
            title: t("Ship"),
            field: "sd_ship_id",
            hidden: true,
          },
          {
            title: t("Owner Last Name"),
            field: "sd_owner_lname",
          },
          {
            title: t("Owner First Name"),
            field: "sd_owner_fname",
          },
          {
            title: t("Port"),
            field: "p_name",
          },
          {
            title: t("Ship's Register Number"),
            field: "sd_aa",
          },
          {
            title: t("Ship's Name"),
            field: "sd_name",
          },
          {
            title: t("From date"),
            field: "sd_dt_from",
            render: (rowData) => {
              return (
                <span>{dayjs(rowData?.sd_dt_from).format("DD/MM/YYYY")}</span>
              );
            },
          },
          {
            title: t("To date"),
            field: "sd_dt_to",
            render: (rowData) => {
              return (
                <span>{dayjs(rowData?.sd_dt_to).format("DD/MM/YYYY")}</span>
              );
            },
          },
        ]}
        data={(query) => queryFunction(query, fetchShipData, setIsError, id)}
        actions={[
          {
            icon: () => <Add />,
            tooltip: t("Add"),
            isFreeAction: true,
            onClick: () => {
              setIsCreateDialogOpen(true);
            },
          },
          {
            icon: () => <Visibility style={{ color: "#000" }} />,
            tooltip: t("View Nautical Crew list"),
            onClick: (event, rowData) => {
              setSelectedItem(rowData);
              history.push(
                `/nauticalcrewlist/shiprecordhd/${rowData.sd_id}?shipname=${singleShipName?.dds}&ship=${id}`
              );
            },
          },
          {
            icon: () => <Edit style={{ color: "#1E90FF" }} />,
            tooltip: t("Edit"),
            onClick: (event, rowData) => {
              setIsUpdateDialogOpen(true);
              setSelectedItem(rowData);
            },
          },
          {
            icon: () => <Delete style={{ color: "#B22222" }} />,
            tooltip: t("Delete"),
            onClick: (event, rowData) => {
              setIsDeleteDialogOpen(true);
              setSelectedItem(rowData);
            },
          },
        ]}
      />
      <CreateDialog
        refetchData={refreshTable}
        open={isCreateDialogOpen}
        close={() => setIsCreateDialogOpen(false)}
        ship_id={id}
        refetch={refreshTable}
      />
      <UpdateDialog
        open={isUpdateDialogOpen}
        close={() => setIsUpdateDialogOpen(false)}
        selectedItem={selectedItem}
        refetch={refreshTable}
        ship_id={id}
      />
      <GovGrDeleteModalDialog
        title={t("Delete Ship Data")}
        message={t("Are you sure you want to delete the selected Ship Data")}
        fieldName="sd_id"
        open={isDeleteDialogOpen}
        close={() => setIsDeleteDialogOpen(false)}
        selectedItem={selectedItem}
        deleteService={deleteShipData}
      />
    </>
  );
}

export default ShipData;
